import {
  ApplicationConfigurationResolverActions,
  ApplicationConfigurationApiActions,
} from './application-configuration.actions';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppleDevicesService } from '@rocksoft/mdm-sdk-v2';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';

@Injectable()
export class ApplicationConfigurationEffects {
  constructor(
    private readonly actions: Actions,
    private readonly appleDevicesService: AppleDevicesService
  ) {}

  applicationConfigurationRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(ApplicationConfigurationResolverActions.configurationRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.appleDevicesService.getApplicationConfigurations(udid, '2.0'),
          (configurations) =>
            ApplicationConfigurationApiActions.configurationLoaded({
              configurations: configurations.map((configuration) => ({
                ...configuration,
                udid: udid,
              })),
            }),
          (error) => ApplicationConfigurationApiActions.configurationLoadedError({ error })
        )
      )
    );
  });
}
